import QaEvent from './qaEvent';
import QaEventProps from './qaEventProps';

class HomePageViewEvent implements QaEvent {
  public getEvent(props: QaEventProps) {
    return {
      event: props.event,
      pageName: props.pageName,
      clientName: props.clientName,
      category: props.category
    };
  }
}

export default HomePageViewEvent;
